import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Recibís todo el material (Ebook, plan, recetas y bonus) en tu correo electrónico inmediatamente después de realizar el pago. Podés leerlo en tu celular, tablet o computadora, o imprimirlo si preferís.'
}, {
  q: '¿Cuándo lo recibo?',
  a: '¡Inmediatamente! Una vez que el pago es aprobado, el sistema te envía automáticamente un mail con el acceso a todo el material para que puedas empezar hoy mismo.'
}, {
  q: '¿Funciona si tengo metabolismo lento o hipotiroidismo?',
  a: '¡Justamente para eso fue creado! El enfoque principal del programa es desinflamar y reactivar metabolismos dañados o lentos mediante alimentación estratégica.'
}, {
  q: '¿Tengo que hacer ejercicio extremo?',
  a: 'No es obligatorio. El 80% de los resultados en estas 3 semanas vendrán de tu alimentación. Si ya hacés ejercicio, genial. Si no, el plan te enseñará a incorporar movimiento suave y progresivo.'
}, {
  q: '¿Es apto para vegetarianas?',
  a: 'Sí, el plan incluye opciones y reemplazos para que puedas adaptarlo perfectamente si no consumís carne.'
}, {
  q: '¿Puedo hacerlo si tengo más de 50 años?',
  a: '¡Por supuesto! De hecho, muchas de nuestras mejores historias de éxito son de mujeres en pre-menopausia o menopausia que lograron destrabar su peso con este método.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-white" data-id="element-32">
      <div className="container mx-auto px-4 max-w-3xl fade-in-section" data-id="element-33">
        <div className="text-center mb-12" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-35">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-coral shadow-md bg-white' : 'border-gray-200 bg-bg-warm hover:border-coral/50'}`} data-id="element-37">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-38">
                <span className="font-bold text-text-dark text-lg pr-4" data-id="element-39">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="text-coral flex-shrink-0" data-id="element-40" /> : <ChevronDownIcon className="text-text-light flex-shrink-0" data-id="element-41" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-42">
                <p className="text-text-medium" data-id="element-43">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}